import React, { useEffect, useState, Fragment } from "react";
import { Row, Col } from "reactstrap";
import { CommonModal, Spinner } from "../../AbstractElements";
import { Done, Large } from "../../Constant";
import { getBookingColumns } from "../../Data/Booking/BookingHistory";
import {
  getManualBookings,
  assignDriverToBooking,
  getCarCurrentIdbyDriver
} from "../../Services/Driver.service";
import { showAlert } from "../../Services/Shared.service";
import DataTable from "react-data-table-component";
import CommonToolTip from "../Common/Component/CommonToolTip";
import moment from "moment";
import StatusIcons from "../../CommonElements/StatusIcons";

const AssignBooking = ({
  LargeModaltoggle,
  title,
  Large,
  setShowApiLoader,
  globalCityField,
  assignBookingDriverObj,
}) => {
  const [bookingData, setBookingData] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState({});
  const [carCurrentStatusId, setCarCurrentStatusId] = useState(null);
  const [loader,setLoader] = useState(false)

  const onBookingSelected = (element) => {
    setSelectedBooking(element);
  };
  const assignBooking = () => {
    setShowApiLoader(true);
    console.log(selectedBooking, "selectedBookingData");
    console.log(assignBookingDriverObj, 'assignBookingDriverObj');
    let isOnTripAssign = assignBookingDriverObj.status == "OnTrip" ? true : false;
    let isAssignLogoutDriver =
      assignBookingDriverObj.status == "Inactive" ? true : false;
    let obj = {
      bookingId: selectedBooking.id,
      carCurrentStatusId: carCurrentStatusId,
      carTypeId: assignBookingDriverObj?.carTypeId,
      isOnTripAssign: isOnTripAssign,
      isAssignLogoutDriver: isAssignLogoutDriver,
      reAssign: selectedBooking.currentBookingStatusType == "Confirmed" || selectedBooking.currentBookingStatusType == "ReachedPickup" ? true : false
    };
    console.log(obj, "obj");
    assignDriverToBooking(obj)
      .then((assignDriverRes) => {
        setShowApiLoader(false);
        LargeModaltoggle();
      })
      .catch((err) => {
        setShowApiLoader(false);
        showAlert("error",err.response?.data?.message ? err.response.data.message : "Something went wrong");
      });
  };
  useEffect(() => {
    if (!Large) return;
    setLoader(true);
    console.log(assignBookingDriverObj, "assignBookingDriverObj");
    const serviceCityId = assignBookingDriverObj?.serviceCityId || null;
    let obj = {
      page: 0,
      size: 20,
      serviceCityId: serviceCityId,
    };
    getManualBookings(obj)
      .then((result) => {
        setLoader(false);
        if (result.data && result.data.length > 0) {
          setBookingData(result.data);
        }
      })
      .catch((err) => {
        setLoader(false);
        setBookingData([]);
        showAlert("error", "Something went wrong");
      });
    getCarCurrentIdbyDriver(assignBookingDriverObj.id).then((result) => {
      if (result.data) {
        setCarCurrentStatusId(result.data);
      }
    }).catch((err) => {
      showAlert("error",err.response?.data?.message ? err.response.data.message :  "Something went wrong");
      LargeModaltoggle();
    });
  }, [Large]);

  const processData = bookingData.map((element, index) => {
    return {
      id: element.id,
      booking_number: element.megaCabsBookingNo
        ? element.megaCabsBookingNo
        : "-",
      pickup_time: element.pickUpDateTime
        ? moment(new Date(element.pickUpDateTime)).format("MMM DD HH:mm")
        : "-",
      customer_name: element.custName ? element.custName : "-",
      phone_number: element.custMobile ? element.custMobile : "-",
      pickup_location: element.pickUpAddress
        ? // <>
        //   <span id={"pickupLocation" + index}>{element.pickUpAddress}</span>
        //   <CommonToolTip
        //     options={{
        //       placement: "left",
        //       target: "pickupLocation" + index,
        //     }}
        //   >
        //     {element.pickUpAddress}
        //   </CommonToolTip>
        // </>
        element.pickUpAddress
        : "-",
      drop_location: element.destAddress ? (
        <>
          <span id={"dropLocation" + index}>
            {element.destAddress.includes("Kempegowda")
              ? "Kempegowda Airport"
              : element.destAddress}
          </span>
          <CommonToolTip
            options={{
              placement: "left",
              target: "dropLocation" + index,
            }}
          >
            {element.destAddress}
          </CommonToolTip>
        </>
      ) : (
        "-"
      ),
      status: element.currentBookingStatusType ? (
        <>
          <span className="status-icon">
            <span id={"statusIcons" + index}>
              <StatusIcons statusType={element.currentBookingStatusType} />
            </span>
            <CommonToolTip
              options={{
                placement: "left",
                target: "statusIcons" + index,
              }}
            >
              {element.currentBookingStatusType}
            </CommonToolTip>
          </span>
        </>
      ) : (
        "-"
      ),
      booking_via: element.bookingViaType ? element.bookingViaType : "-",
      pickup_type: element.pickupType ? element.pickupType : "-",
      mmt_reference_id: element.mmtReferenceId ? element.mmtReferenceId : "-",
      action: (
        <div key={index} onClick={() => onBookingSelected(element)}>
          {selectedBooking?.id && selectedBooking.id == element.id ? (
            <i className="fa fa-check"></i>
          ) : (
            <i className="fa fa-user-plus"></i>
          )}
        </div>
      ),
    };
  });

  console.log(processData, "processDatas");
  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={LargeModaltoggle}
      size="xl"
    >
      <Row className="book-a-cab">
        <Row>
          <Col className="col-12 mt-2 table-responsive support-table assign-table-list">
            <DataTable
              columns={getBookingColumns(bookingData)}
              data={processData}
              center={true}
              onRowClicked={onBookingSelected}
              fixedHeader
              fixedHeaderScrollHeight="51vh"
              pagination
              progressPending={loader}
              progressComponent={<div className="loader-box" style={{ height: "51vh" }}>
                <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
              </div>}
            />
          </Col>
        </Row>
        <Row className="submit-booking">
          <button
            disabled={selectedBooking?.id ? false : true}
            className="btn btn-primary"
            onClick={assignBooking}
          >
            {Done}
          </button>
        </Row>
      </Row>
    </CommonModal>
  );
};

export default AssignBooking;
